<template>
  <div>
    <v-chip
      style="width: 100%"
      :close="Boolean(value)"
      :disabled="disabled"
      :color="chipColor"
      outlined
      @click="open()"
      @click:close="clear()"
    >
      <span v-if="!value">{{ emptyText }}</span>
      <span v-if="value" style="width: 95%" class="text-truncate">{{ value.name }}</span>
    </v-chip>

    <v-dialog
      v-model="viewDialog"
      :width="width"
    >
      <v-card class="mx-auto" tile>
        <v-list dense>
          <v-subheader>
            <div class="ma-2 mt-8" style="width: 100%">
              <v-text-field
                solo
                clearable
                dense
                autofocus
                :placeholder="searchPlaceholder"
                v-model="keyword"
                append-icon="fa fa-search"
                @click:close="keyword = ''"
              />
            </div>
          </v-subheader>

          <v-list-item
            v-for="(item, i) in filteredItems"
            @click="closeSelect(item)"
            :key="i"
          >
            <v-list-item-icon>
              <v-icon color="primary" v-text="isSelected(item) ? 'fa fa-check' : ''"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import src from './src'
export default src
</script>
